import React from "react";
import {
  Box,
  Typography,
  Stack,
  styled,
  Avatar,
  Divider,
} from "@mui/material";
import {
  User,
  Mail,
  Building2,
  Phone,
  Tag,
  Hash
} from "lucide-react";

const InfoCard = styled(Box)(({ theme }) => ({
  background: 'white',
  borderRadius: '24px',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.04), 0 4px 6px rgba(0, 0, 0, 0.02)',
  border: '1px solid #F0F0F5',
  padding: '32px',
  marginBottom: '24px'
}));

const DetailItem = ({ icon: Icon, label, value }) => (
  <Stack direction="row" spacing={2} alignItems="flex-start">
    <Box sx={{ p: 1, bgcolor: '#F9FAFB', borderRadius: '10px', color: '#6B7280' }}>
      <Icon size={18} />
    </Box>
    <Box>
      <Typography variant="caption" sx={{ color: '#9CA3AF', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
        {label}
      </Typography>
      <Typography variant="body2" sx={{ color: '#1F2937', fontWeight: 600, mt: 0.2 }}>
        {value || 'N/A'}
      </Typography>
    </Box>
  </Stack>
);

export default function SingleTicketCard({ ticket }) {
  if (!ticket) return null;

  return (
    <InfoCard>
      <Stack alignItems="center" sx={{ mb: 4 }}>
        <Avatar
          sx={{
            width: 80,
            height: 80,
            bgcolor: '#EEF2FF',
            color: '#4F46E5',
            fontSize: '24px',
            fontWeight: 800,
            border: '4px solid white',
            boxShadow: '0 10px 15px -3px rgba(79, 70, 229, 0.1)'
          }}
        >
          {ticket.name?.split(' ').map(n => n[0]).join('').toUpperCase() || 'U'}
        </Avatar>
        <Typography variant="h6" fontWeight={800} sx={{ mt: 2, color: '#111827' }}>
          {ticket.name}
        </Typography>
        <Typography variant="caption" sx={{ color: '#4F46E5', fontWeight: 700, bgcolor: '#EEF2FF', px: 1.5, py: 0.5, borderRadius: '20px', mt: 1 }}>
          {ticket.category || 'Support'}
        </Typography>
      </Stack>

      <Divider sx={{ mb: 4, borderColor: '#F3F4F6' }} />

      <Stack spacing={3}>
        <DetailItem icon={Mail} label="Email Address" value={ticket.email} />
        <DetailItem icon={Phone} label="Mobile Number" value={ticket.mobile} />
        <DetailItem icon={Building2} label="Company Name" value={ticket.businessName} />
        {ticket.assignee && (
          <DetailItem icon={User} label="Assigned Agent" value={ticket.assignee} />
        )}
      </Stack>
    </InfoCard>
  );
}
